import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgGardeshgari = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#A30E06'
      fillRule='evenodd'
      d='M5.752 1h8.009l4.194 7.282-1.154 2.003-2.125-3.689H5.649l-4.119 7.15L0 11.089l3.714-6.448h9.498l-.564-.98H4.27z'
      clipRule='evenodd'
    />
    <path
      fill='#A30E06'
      fillRule='evenodd'
      d='m5.96 22-4.003-6.953L6.15 7.766h2.308l-2.124 3.689 4.514 7.836h8.236l-1.53 2.657h-7.429l-4.749-8.244-.564.979 4.189 7.27z'
      clipRule='evenodd'
    />
    <path
      fill='#A30E06'
      fillRule='evenodd'
      d='m24 11.318-4.005 6.953h-8.388l-1.154-2.004h4.25l4.513-7.836-4.118-7.15h3.06l3.715 6.448-4.749 8.245h1.129l4.188-7.271z'
      clipRule='evenodd'
    />
    <path
      fill='#1AB4B8'
      d='M14.705 12.77a3.173 3.173 0 0 0-1.542-4.207 3.16 3.16 0 0 0-4.197 1.545 3.173 3.173 0 0 0 1.542 4.208 3.16 3.16 0 0 0 4.197-1.546'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgGardeshgari)
export default ForwardRef
